import React, { Suspense, useState, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { NavBar, TopBar } from './components';
import './Dashboard.css';

const Dashboard = (props) => {
  const { route } = props;
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const location = useLocation();

  // Fechar menu mobile quando a rota mudar
  useEffect(() => {
    setOpenNavBarMobile(false);
  }, [location.pathname]);

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  const openNavBar = () => {
    setOpenNavBarMobile(true);
  };

  return (
    <div className="dashboard-container h-100 w-100 d-flex flex-column overflow-hidden">
      <div className="d-lg-none topbar-mobile">
        <TopBar openNavBar={openNavBar} />
      </div>

      <div className="d-flex flex-grow-1 overflow-hidden position-relative">
        <NavBar
          className="navbar-desktop"
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />

        <main 
          className="flex-grow-1 overflow-auto dashboard-main" 
        >
          <Suspense fallback={<div className="text-center p-3"><Spinner animation="border" /></div>}>
            {renderRoutes(route.routes)}
          </Suspense>
        </main>

      </div>
    </div>
  );
};

export default Dashboard;
